import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import ApiClient from "../ApiClient";
import { getRequestGlobal } from "../../../API/global";
import DeleteIcon from "@mui/icons-material/Delete";
import { isTimeUp } from "../../Helper";

import EditIcon from "@mui/icons-material/Edit";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CardOtt = ({ impoData }) => {
  const { getRequest, postRequest } = ApiClient();
  const [preData, setPredata] = useState([]);
  const [language, setLanguage] = useState({});
  const navigate = useNavigate();
  const [showAddNewEntryOtt, setShowAddNewEntryOtt] = useState(false);

  const [oldYearData, setOldYearData] = useState([]);

  const targetDateString = process.env.REACT_APP_TARGET_DATE; // Date from the .env file
  const timeUp = isTimeUp(targetDateString); // Check if the time is up

  useEffect(() => {
    const fetchData = async () => {
      try {
        const preData = await getRequest("ott");
        const data = preData.data;
        setPredata(data);
        const olddata = preData.oldlistdata;

        setOldYearData(olddata);
        // const data = preData.data;
        if (data && data.length <= 1) setShowAddNewEntryOtt(true);
        // setPredata(data);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    getRequestGlobal("language_list", {})
      .then((data) => {
        // console.log(data, "language data ott");
        setLanguage(data.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete?");
    if (confirmDelete) {
      try {
        const data = await postRequest(`ott/delete/${id}`);
        if (data.status) {
          window.location.reload();
        }
        // setPredata(preData.filter((item) => item.id !== id));
      } catch (error) {
        console.error("Delete error:", error);
      }
    }
  };

  const handleEditClick = (id) => {
    navigate(`/ott/${id}`);
  };

  const handleViewClick = (id) => {
    navigate(`/ott/view/${id}`);
  };
  const addNewEntryOtt = () => {
    navigate("/ott");
  };

  const [ottClosed, setOttClosed] = useState();

  useEffect(() => {
    if (impoData?.ott) {
      const OTT = impoData.ott.close;
      console.log(OTT);
      setOttClosed(OTT);
    }
  }, [impoData]);

  return (
    <>

      {preData.length === 0 ? (
        <div className="text-center">
          <p className="no-content">
            {" "}
            <h4>
              You haven't added a entry yet. To get started, simply click on Add
              New Entry button{" "}

            </h4>
          </p>

        </div>
      ) : (
        <div className="card-container">
          <>
            {preData.map((item) => (
              <div className="card_con" key={item.id}>
                <h1 className="title">{item.title_in_english}</h1>
                <ul className="listView">
                  <li>
                    <h5>Title of Webseries</h5> <h6>{item.title}</h6>
                  </li>
                  <li>
                    <h5>Language of Webseries</h5>{" "}
                    <h6>
                      {item.language_id
                        ? language?.[item.language_id]
                          ? language[item.language_id]
                          : ""
                        : ""}
                    </h6>
                  </li>
                </ul>
                <div className="button_con">
                  {/* <Button variant="contained" href={`/ott/view/${item.id}`}>View</Button> */}
                  {item.step >= 8 ? (
                    <>
                      <Button
                        style={{ color: "#fff" }}
                        onClick={() => handleViewClick(item.id)}
                      >
                        View & Print
                      </Button>
                    </>
                  ) : (
                    <>
                      {ottClosed === 1 ? (
                        <>
                          <Button
                            variant="contained"
                            onClick={() => handleEditClick(item.id)}
                          >
                            <EditIcon />
                            Edit
                          </Button>
                          <Button
                            className="del_btn"
                            variant="contained"
                            onClick={() => handleDelete(item.id)}
                            startIcon={<DeleteIcon sx={{ color: "#f67474" }} />}
                          >
                            Delete
                          </Button>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </div>
              </div>
            ))}
          </>
        </div>
      )}

      {!Object.keys(oldYearData).length ? (
        <div className="card_con mt-4">
          <Typography variant="body1">
            No previous submissions available.
          </Typography>
        </div>
      ) : (
        Object.entries(oldYearData)
          .sort((a, b) => Number(b[0]) - Number(a[0])) // Sort years descending (latest first)
          .map(([year, items]) => (
            <Accordion sx={{ mt: 2 }} key={year} className="accordian_class">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel-${year}-content`}
                id={`panel-${year}-header`}
              >
                <Typography variant="h6" component="span">
                  Your Previous Submissions - {year}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className="card-container">
                  {items.map((item) => (
                    <div className="card_con" key={item.id}>
                      <h1 className="title">{item.title_in_english}</h1>
                      <ul className="listView">
                        <li>
                          <h5>Title of Webseries</h5> <h6>{item.title}</h6>
                        </li>
                        <li>
                          <h5>
                            Language of <br />
                            Webseries
                          </h5>{" "}
                          <h6>
                            {item.language_id
                              ? language?.[item.language_id]
                                ? language[item.language_id]
                                : ""
                              : ""}
                          </h6>
                        </li>
                      </ul>
                      {/* <div className="button_con">
                        <Button
                          style={{ color: "#fff" }}
                          onClick={() => handleViewClick(item.id)}
                        >
                          View & Print
                        </Button>
                      </div> */}
                    </div>
                  ))}
                </div>
              </AccordionDetails>
            </Accordion>
          ))
      )}
    </>
  );
};

export default CardOtt;
